import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-popup',
  templateUrl: './password-popup.component.html',
  styleUrls: ['./password-popup.component.scss']
})
export class PasswordPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
